<template>
    <div class="box px-5 sm:px-10 pt-10 pb-4 w-full">
        <div class="flex flex-row content-center items-center mb-5">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 text-yellow-200" viewBox="0 0 20 20" fill="currentColor">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
            <div v-if="subscription">
                <h4 class="m-0 text-lg md:text-xl text-green-400 font-bold ml-2">{{subscription.subscription.name}} </h4>
            </div> 
           
        </div>
        <div class="w-full grid grid-cols-5 gap-4 xs:grid-cols-2 xs:gap-2 items-start md:items-start mb-5 md:mb-0" v-if="subscription">
            <div class="mb-5 ">
                <h5 class="font-bold">{{dashboardTranslate[language].card.accompanied.plan}} </h5>
                <p class="text-sm">{{subscription.subscription.name}}</p>
            </div>
            <div class="mb-5 "  v-if="subscription.subscription.companionsNumber">
                <h5 class="font-bold">{{dashboardTranslate[language].card.accompanied.companions}}</h5>
                <p class="text-sm" >{{subscription.subscription.companionsNumber }} 
                    <span> {{dashboardTranslate[language].card.accompanied.companionsText}}<span v-if="subscription.subscription.companionsNumber > 1 ">s </span></span>
                </p>
            </div>
            <div class="mb-2 ">
                <h5 class="font-bold">{{dashboardTranslate[language].card.accompanied.typeofPayment}}</h5>
                <p class="text-sm" >
                    <!-- change translate --> 
                    <span  v-if="subscription.subscription.currentAmount.paymentTerm">
                        {{ dashboardTranslate[language].card.accompanied[subscription.subscription.currentAmount.paymentTerm.toLowerCase()] }}
                    </span> 
                </p>
            </div>
            <div class="mb-2 " v-if="subscription.subscription">
                <h5 class="font-bold">{{dashboardTranslate[language].card.accompanied.qouta}}</h5>
                <p class="text-sm">${{subscription.subscription.currentAmount.netTotalAmount}} {{currency}}</p>
            </div>
            
            <div class="mb-2">
                <h5 class="font-bold">{{dashboardTranslate[language].card.accompanied.since}}</h5>
                <p class="text-sm">{{getMemberSince }}</p>
            </div>
            
        </div>
    </div>
</template>
<script>
import { computed } from '@vue/runtime-core'
import { useStore } from 'vuex'
    import { dashboardTranslate } from '@/translations/Dashboard.js'

export default {
    name : "DashboardTeamCardInformation",
    setup() {
        
        const store = useStore()
        const subscription = computed(() => {
            return store.state.Checkout.data.userSubscription.data

        })
        const currentPlan = computed(() =>{

            return store.state.Plans.data.currentPlan
        })
        const language = computed( ()=> {
                return  localStorage.getItem('viva-translate') ? localStorage.getItem('viva-translate') : 'es';
            })
        const getRenewalDate =  computed( () => {
             if( subscription.value ){
            const expire = new Date(subscription.value.subscription.renewalDate )
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
              const lang = language.value  == 'es' ? 'es-ES' : 'en-US'
                return expire.toLocaleDateString(lang, options)
             }
            })

        const currency = computed(() => {
            return  localStorage.getItem('viva-currency') ? localStorage.getItem('viva-currency') : 'MXN';
        })

         const getMemberSince = computed( () => {
             if( subscription.value ){
                const expire = new Date(subscription.value.subscription.creationDate )
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                const lang = language.value  == 'es' ? 'es-ES' : 'en-US'
                return expire.toLocaleDateString(lang, options)
             }
        })


        return { subscription, getRenewalDate, getMemberSince, dashboardTranslate, language, currency, currentPlan}
    },
}
</script>